import src from "IMAGE";
export default { src, width: 699, height: 534, blurWidth: 0, blurHeight: 0};
